<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0">Роли пользователей</h4>
					<div class="page-title-right">
						<ol class="breadcrumb m-0">
							<li class="breadcrumb-item">
								<router-link :to="{path: '/'}">Главная</router-link>
							</li>
							<li class="breadcrumb-item active">Роли пользователей</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<div class="row mb-2">
							<div class="col-md-6">
								<div class="mb-3">
									<a href="javascript:void(0);" class="btn btn-success waves-effect waves-light">
										<i class="mdi mdi-plus me-2"></i> Добавить
									</a>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-inline float-md-end mb-3">
									<div class="search-box ms-2">
										<div class="position-relative">
											<input type="text" class="form-control rounded bg-light border-0" placeholder="Поиск...">
											<i class="mdi mdi-magnify search-icon"></i>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="table-responsive mb-4">
							<table class="table table-centered table-nowrap mb-0">
								<thead>
								  <tr>
									<th scope="col" style="width: 50px;">
										<div class="form-check font-size-16">
											<input type="checkbox" class="form-check-input" id="contacusercheck">
											<label class="form-check-label" for="contacusercheck"></label>
										</div>
									</th>
									<th scope="col">api_name</th>
									<th scope="col">Название</th>
									<th scope="col" style="width: 200px;">Действие</th>
								  </tr>
								</thead>
								<tbody>
									<tr v-for="role in userRoles" :key="role.id">
										<th scope="row">
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" :id="'contacusercheck'+role.id" />
												<label class="form-check-label" :for="'contacusercheck'+role.id"></label>
											</div>
										</th>
										<td>{{role.apiname}}</td>
										<td>{{role.name}}</td>
										<td>
											<ul class="list-inline mb-0">
												<li class="list-inline-item">
													<a href="javascript:void(0);" class="px-2 text-primary"><i class="uil uil-pen font-size-18"></i></a>
												</li>
												<li class="list-inline-item">
													<a href="javascript:void(0);" class="px-2 text-danger"><i class="uil uil-trash-alt font-size-18"></i></a>
												</li>
												<li class="list-inline-item dropdown">
													<a class="text-muted dropdown-toggle font-size-18 px-2" href="#" role="button" data-bs-toggle="dropdown" aria-haspopup="true">
														<i class="uil uil-ellipsis-v"></i>
													</a>
													<div class="dropdown-menu dropdown-menu-end">
														<a class="dropdown-item" href="#">Action</a>
														<a class="dropdown-item" href="#">Another action</a>
														<a class="dropdown-item" href="#">Something else here</a>
													</div>
												</li>
											</ul>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row mt-4">
							<div class="col-sm-6">
								<div>
									<p class="mb-sm-0">Показано с 1 по 10 из 12 записей</p>
								</div>
							</div>
							<div class="col-sm-6">
								<div class="float-sm-end">
									<ul class="pagination mb-sm-0">
										<li class="page-item disabled">
											<a href="#" class="page-link"><i class="mdi mdi-chevron-left"></i></a>
										</li>
										<li class="page-item active">
											<a href="#" class="page-link">1</a>
										</li>
										<li class="page-item">
											<a href="#" class="page-link">2</a>
										</li>
										<li class="page-item">
											<a href="#" class="page-link"><i class="mdi mdi-chevron-right"></i></a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'UserRoles',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Роли пользователей | Krasp'});
	},
	data: () => ({
		userRoles: [
			{id: 1, apiname: 'admin', name: 'Администратор'},
		],
	}),
	methods: {
		
	},
	beforeMount(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	computed: {},
	components: {
		//Navbar,
	},
};
</script>